import Dropdown from "../../components/Dropdown/Dropdown"
import { CUSTODIAL_FEE } from "../../config/consts"

export const CustodialFee = ({ value, setValue, classes }) => {
  return (
    <>
      <Dropdown
        value={value}
        setValue={setValue}
        menuItems={CUSTODIAL_FEE?.map((item) => ({ ...item, label: `$${item.value}` }))}
        className={classes}
        variant="standard"
        placeholder="$"
        label="Custodial Fee:"
      />
    </>
  )
}
